import { OPCOES_JANELA_VENCIMENTO_DIAS, STATUS_AVALIACAO_OPCOES, STATUS_PRAZO_LABELS } from '../../utils/acreditacaoOpcoes';

const FILTROS_STATUS = [{ value: 'todos', label: 'Todos' }, ...STATUS_AVALIACAO_OPCOES.map((o) => ({ value: o.value, label: o.label }))];
const FILTROS_JANELA_PRAZO = [
  { value: 'todos', label: 'Todos' },
  { value: 'a_vencer', label: STATUS_PRAZO_LABELS.a_vencer },
  { value: 'vencido', label: STATUS_PRAZO_LABELS.vencido },
];

// Painel de filtro compartilhado pelas telas de Vencimentos/Corretivas — por hospital
// (AbaVencimentos.jsx/AbaCorretivas.jsx) e no portfólio inteiro (Dashboard). As props batem
// exatamente com o retorno de useFiltroVencimentos, então dá pra usar via `<FiltrosPrazo {...filtro} />`.
export default function FiltrosPrazo({
  filtroCore,
  setFiltroCore,
  filtroStatus,
  setFiltroStatus,
  filtroVigencia,
  setFiltroVigencia,
  dias,
  setDias,
}) {
  return (
    <div className="filtros-painel mb-3">
      <div className="filtros-painel__linha">
        <span className="filtros-painel__label">Próximo do vencimento em</span>
        <div className="filter-tabs">
          {OPCOES_JANELA_VENCIMENTO_DIAS.map((d) => (
            <button key={d} type="button" className={`filter-tab${dias === d ? ' is-active' : ''}`} onClick={() => setDias(d)}>
              {d} dias
            </button>
          ))}
        </div>
      </div>
      <div className="filtros-painel__linha">
        <span className="filtros-painel__label">Escopo</span>
        <div className="filter-tabs">
          <button type="button" className={`filter-tab${filtroCore === 'todos' ? ' is-active' : ''}`} onClick={() => setFiltroCore('todos')}>
            Todos
          </button>
          <button type="button" className={`filter-tab${filtroCore === 'core' ? ' is-active' : ''}`} onClick={() => setFiltroCore('core')}>
            Somente CORE
          </button>
        </div>
      </div>
      <div className="filtros-painel__linha">
        <span className="filtros-painel__label">Status</span>
        <div className="filter-tabs">
          {FILTROS_STATUS.map((f) => (
            <button key={f.value} type="button" className={`filter-tab${filtroStatus === f.value ? ' is-active' : ''}`} onClick={() => setFiltroStatus(f.value)}>
              {f.label}
            </button>
          ))}
        </div>
      </div>
      <div className="filtros-painel__linha">
        <span className="filtros-painel__label">Situação</span>
        <div className="filter-tabs">
          {FILTROS_JANELA_PRAZO.map((f) => (
            <button key={f.value} type="button" className={`filter-tab${filtroVigencia === f.value ? ' is-active' : ''}`} onClick={() => setFiltroVigencia(f.value)}>
              {f.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
